import type { ChannelSelectionTopic, JsonObject } from "@/api";
import { getAtPath } from "./recipeCoerce";

// config 의 policy.mux.* 키 조회. 채널 매핑 UI(ChannelSelectionEditor)가 config 기대 채널과
// 데이터셋 구조의 불일치 경고를 계산할 때 쓴다. override 행 생성은 BE 재조립이 담당한다.
// 제출 payload 의 channel_selection 을 받으면 BE 가 `~`/`++` 교체 override 를 주입한다.

// topic 축은 wire 계약(ChannelSelectionTopic)이 소유한다. 이 파일은 그 topic 의 config 경로만 안다.
export const MUX_TOPIC_PATHS: Record<ChannelSelectionTopic, string> = {
  observation_image: "policy.mux.observation_image",
  observation_vector: "policy.mux.observation_vector",
  action: "policy.mux.action",
};

export type MuxTopic = ChannelSelectionTopic;

export const MUX_TOPICS = Object.keys(MUX_TOPIC_PATHS) as MuxTopic[];

// config 본문에 있는 topic 의 mux 키 목록(없거나 객체가 아니면 빈 목록).
export function configMuxKeys(data: JsonObject, topic: MuxTopic): string[] {
  const mux = getAtPath(data, MUX_TOPIC_PATHS[topic]);
  if (mux === null || typeof mux !== "object" || Array.isArray(mux)) {
    return [];
  }
  return Object.keys(mux);
}

// config 본문에 이미 있는 mux 카메라 이름 목록.
export function configMuxCameras(data: JsonObject): string[] {
  return configMuxKeys(data, "observation_image");
}
